<h2 mat-dialog-title>Please watch the training video on how to access the Application
    <button class="cancel-button" (click)="onNoClick()">&times;</button>
</h2>
<mat-dialog-content>
    <video id="myVideo" width="400" height="300" controls>
        <source src="{{videoSource}}" type="video/mp4">
        Your browser does not support the video tag.
    </video>


</mat-dialog-content>
<!-- <mat-dialog-actions>
    <button mat-button (click)="onNoClick()" class="play">Skip</button>
</mat-dialog-actions> -->